import React, { useState, memo, useEffect, useLayoutEffect } from 'react'
import PropTypes from 'prop-types'
import { Player } from '@lottiefiles/react-lottie-player'
import { GifContainer } from './Loading.style.js'
import { animations } from './animations'
// import 'styles/Loading.css'

let initialIndex = 0
const animationCount = animations.length

// change the sorting of the keys
const shuffle = () => {
  animations.sort(() => Math.random() - 0.5)
}

// increment a given index within a range
const incrementIndex = (index) => (index + 1) % animationCount

const Loading = (props) => {
  const [index, updateIndex] = useState(initialIndex)

  // save the component's new index when player completes
  const handleEvent = (event) => {
    if (event !== 'complete') return
    const newIndex = incrementIndex(index)
    updateIndex(newIndex)
  }

  useEffect(() => {
    // whenever mounted or unmounted cache the index
    if (index === 0) shuffle()
    return () => {
      initialIndex = incrementIndex(index)
      if (index === 0) shuffle()
    }
  }, [index])

  return (
    <GifContainer {...props}>
      <div>
        <AsyncAnimationPlayer
          autoplay
          keepLastFrame
          onEvent={handleEvent}
          index={index}
        />
        {props.children}
      </div>
    </GifContainer>
  )
}

export const AsyncAnimationPlayer = memo(({ index, ...props }) => {
  const [data, updateData] = useState(null)
  useLayoutEffect(() => {
    // pick an animation and await import
    const animation = animations[index]
    import(`./animations/${animation}`).then(updateData)
  }, [index])
  if (data === null) return <></>
  return <Player {...props} src={data} />
})

AsyncAnimationPlayer.propTypes = {
  index: PropTypes.number,
}

Loading.defaultProps = {
  style: {},
}

Loading.propTypes = {
  children: PropTypes.node,
  contained: PropTypes.bool,
  style: PropTypes.object,
  loaderId: PropTypes.string,
  size: PropTypes.string,
  background: PropTypes.string,
}

export default Loading
